module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tournaments) ? _c('div', [_c('md-list', {
    staticClass: "top-tools"
  }, [_c('md-toolbar', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "md-toolbar-section-end"
  }, [(_vm.currentUser) ? _c('md-button', {
    staticClass: "md-fab md-mini md-accent",
    on: {
      "click": function($event) {
        _vm.showCreateTournamentDialog = true
      }
    }
  }, [_c('md-icon', [_vm._v("add")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Create a new tournament")])], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.refetch()
      }
    }
  }, [_c('md-icon', [_vm._v("refresh")])], 1)], 1)]), _vm._v(" "), _c('md-list-item', {
    attrs: {
      "md-expand": ""
    }
  }, [_c('md-icon', [_vm._v("filter_list")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Options")]), _vm._v(" "), _c('md-list', {
    staticClass: "flex-container",
    attrs: {
      "slot": "md-expand"
    },
    slot: "md-expand"
  }, [_c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showThisMonth),
      callback: function($$v) {
        _vm.showThisMonth = $$v
      },
      expression: "showThisMonth"
    }
  }, [_vm._v("This Month")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showNextMonth),
      callback: function($$v) {
        _vm.showNextMonth = $$v
      },
      expression: "showNextMonth"
    }
  }, [_vm._v("Next Month")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showFuture),
      callback: function($$v) {
        _vm.showFuture = $$v
      },
      expression: "showFuture"
    }
  }, [_vm._v("Future")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "md-inset flex-item"
  }, [_c('md-switch', {
    model: {
      value: (_vm.showOlder),
      callback: function($$v) {
        _vm.showOlder = $$v
      },
      expression: "showOlder"
    }
  }, [_vm._v("Older")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-container"
  }, [(_vm.showThisMonth) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": _vm.thisMonthTitle,
      "tournaments": _vm.thisMonthTournaments
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNextMonth) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": _vm.nextMonthTitle,
      "tournaments": _vm.nextMonthTournaments
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFuture) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Future",
      "tournaments": _vm.futureTournaments
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showOlder) ? _c('TournamentList', {
    staticClass: "flex-item",
    attrs: {
      "title": "Older",
      "tournaments": _vm.olderTournaments
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('UpsertTournamentDialog', {
    attrs: {
      "show": _vm.showCreateTournamentDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showCreateTournamentDialog = false
      }
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268de8c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listingComponents/tournaments.vue
// module id = 439
// module chunks = 1